import React from 'react';
import { Clock } from 'lucide-react';
import { FeaturesList } from './index';

const ServicePackageCard = ({ package: pkg }) => {
  // Format price type
  const getPriceTypeLabel = () => {
    if (!pkg.price_type) return 'per event';
    return pkg.price_type === 'fixed' ? 'Fixed Price' : 'Hourly Rate';
  };

  // Format duration
  const getDurationText = () => {
    if (pkg.duration_hours) {
      return `${pkg.duration_hours} hours`;
    }
    return null;
  };

  const durationText = getDurationText();

  return (
    <div className="bg-surface border border-black rounded-lg p-6 transition-all duration-300 hover:shadow-sm hover:border-gray-400 cursor-pointer">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
        {/* Left side - Package info */}
        <div className="flex-1">
          <h4 className="text-lg font-bold text-black mb-2">
            {pkg.package_name || 'Package'}
          </h4>
          <p className="text-sm text-gray-600 mb-4 leading-relaxed">
            {pkg.description || 'No description available'}
          </p>
          
          {/* Duration info */}
          {durationText && (
            <div className="mb-4">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <Clock className="w-4 h-4 flex-shrink-0" />
                <span>{durationText}</span>
              </div>
            </div>
          )}
          
          {/* Features list */}
          <div className="mt-4 w-full overflow-visible">
            <FeaturesList
              features={[
                ...(pkg.includes_items || []),
                ...(pkg.package_features || [])
              ]}
            />
          </div>
        </div>
        
        {/* Right side - Price */}
        <div className="md:text-right">
          <div className="text-2xl font-bold text-black mb-1">
            ${Number(pkg.base_price || 0).toFixed(2)}
          </div>
          <div className="text-xs text-gray-600">{getPriceTypeLabel()}</div>
        </div>
      </div>
    </div>
  );
};

export default ServicePackageCard;

